<template>
    <base-modal :value="value" @input="close"
        modal-classes="modal-danger"
        modal-content-classes="bg-primary"
        :title="comment.title"
    >
        <div class="py-3 text-center">
            <i class="tim-icons icon-quote icon-3x mb-3"></i>
            <blockquote class="blockquote text-white">

                <!-- Keep it on the same line!!! -->
                <p class="mb-5 comment">{{ comment.content }}</p>
                
                <footer class="blockquote-footer text-white">
                    {{ comment.author }}
                </footer>
            </blockquote>
        </div>

        <!--
        <template slot="footer">
            <div class="text-center">
                <base-button type="link" class="text-white" @click="close">{{ $t('common.close') }}</base-button>
            </div>
        </template>
        -->
    </base-modal>
</template>

<script>
    export default {
        
        props: {
            value: {
                type: Object,
                required: true
            },
            comment: {
                type: Object
            }
        },

        methods: {

            close() {
                this.$emit('input', {
                    show: false,
                })
            }
        }
    }
</script>

<style scoped>

    .comment {
        white-space: pre-wrap;
    }

</style>